import _ from 'lodash';
import moment from 'moment';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FuelContractContainer from '../../containers/inventory/FuelContract';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

import FMPText from '../../components/pureForm/FMPText';
import FormComponent from '../../components/FormComponent';
import Button from '@material-ui/core/Button';
import FMPQuarterPicker from '../../components/pureForm/FMPQuarterPicker';
import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FMPSelect from '../../components/pureForm/FMPSelect';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import DeleteIcon from '@material-ui/icons/Delete';
import ResourceUploader from '../../components/form/ResourceUploader';
import FMPTerminalSupplierPicker from '../../components/pureForm/FMPTerminalSupplierPicker';
import FMPProductSelect from '../../components/pureForm/FMPProductSelect';
import FMPBulkCustomerMultiSelect from '../../components/pureForm/FMPBulkCustomerMultiSelect';
import FMPSupplierSelect from '../../components/pureForm/FMPSupplierSelect';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Snackbar from '@material-ui/core/Snackbar';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import SaveFuelSubContractDialog from '../../components/Dialogs/SaveFuelSubContractDialog';

import { allProducts } from '../../libs/products';
import documentIcon from '../../images/document.svg';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';

const styles = (theme) => {
	return {
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 20,
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		formControl: {
			width: '100%',
			margin: '10px 0',
		},
		inputGroup: {
			borderLeft: '5px solid #ccc',
			marginTop: 10,
			marginBottom: 20,
		},
		infoBox: {
			fontSize: 14,
			alignItems: 'center',
			display: 'flex',
			backgroundColor: '#f7f7f7',
			padding: '10px 15px 15px 15px',
			marginTop: 10,
			marginBottom: 5,
		},
		infoIcon: {
			color: '#2196F3',
			width: 32,
			height: 32,
			paddingRight: 5,
			verticalAlign: 'middle',
		},
		documentIcon: {
			marginRight: 12,
			display: 'inline-block',
			width: 34,
			height: 40,
			backgroundImage: `url('${documentIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		note: {
			backgroundColor: '#D8F0FF',
			padding: 20,
			fontSize: 16,
			lineHeight: 1.4,
			marginBottom: 10,
			marginTop: 10,
			border: '1px solid #BADEFB',
		},
	};
};

class SaveFuelContract extends FormComponent {
	constructor(props) {
		super(props);
		const fuelContractId = _.get(this.props, ['match', 'params', 'fuelContractId']);

		this.state = {
			fuelContractId: fuelContractId ? parseInt(fuelContractId, 10) : undefined,
			isUpdate: fuelContractId,
			formFieldError: {},
			quarter: moment().format('YYYY - [Q]Q'),
			startDate: moment().startOf('quarter').format('YYYY-MM-DD'),
			endDate: moment().endOf('quarter').format('YYYY-MM-DD'),
			resourceIds: [],
			finalCalculatedCosts: [],
			bulkCostBulkCustomerIds: [],
			archiveConfirmOpen: false,
			subContracts: [],
			subContractDialogOpen: false,
			editingSubContract: null,
			copySnackbarOpen: false,
		};
	}

	componentDidMount() {
		const { bulkCustomers, searchBulkCustomers, fuelContract, getFuelContract, suppliers, searchSuppliers } = this.props;
		if (_.isEmpty(bulkCustomers)) {
			searchBulkCustomers();
		}
		if (_.isEmpty(suppliers)) {
			searchSuppliers();
		}

		const { isUpdate, fuelContractId } = this.state;
		this.setupFinalCostsArray();

		if (!isUpdate) {
			return;
		}
		if (!fuelContract) {
			getFuelContract({
				params: { fuelContractIds: [fuelContractId] },
			});
		} else {
			const newState = this.fillForm();
			this.setState(newState);
		}
		this.loadSubContracts();
	}

	componentDidUpdate(prevProps, prevState) {
		if (_.isUndefined(prevProps.fuelContract) && !_.isUndefined(this.props.fuelContract)) {
			const newState = this.fillForm();
			this.setState(newState);
		}

		const { startDate, endDate } = this.state;
		if (
			(prevState.startDate !== startDate && endDate) ||
			(prevState.endDate !== endDate && startDate)
		) {
			this.setupFinalCostsArray();
		}

		const { quarter } = this.state;
		if (
			prevState.quarter !== quarter &&
			prevState.startDate === startDate &&
			prevState.endDate === endDate
		) {
			const quarterMoment = moment(quarter, 'YYYY - Q').startOf('quarter');
			const newStartDate = moment(quarterMoment).startOf('quarter').format('YYYY-MM-DD');
			const newEndDate = moment(quarterMoment).endOf('quarter').format('YYYY-MM-DD');
			this.setState({ startDate: newStartDate, endDate: newEndDate });
		}
	}

	setupFinalCostsArray = () => {
		const { startDate, endDate, finalCalculatedCosts } = this.state;

		const indexMoment = moment(startDate);
		const endMoment = moment(endDate);
		const newFinalCalculatedCosts = [];
		while (indexMoment.isBefore(endMoment)) {
			const newStartDate = moment(indexMoment).startOf('month').format('YYYY-MM-DD');
			const newEndDate = moment(indexMoment).endOf('month').format('YYYY-MM-DD');

			let cost = '';
			let bulkCost = '';
			const existing = _.find(finalCalculatedCosts, {
				startDate: newStartDate,
				endDate: newEndDate,
			});
			if (existing) {
				cost = existing.cost || '';
				bulkCost = existing.bulkCost || '';
			}

			newFinalCalculatedCosts.push({
				startDate: newStartDate,
				endDate: newEndDate,
				cost,
				bulkCost,
			});
			indexMoment.add(1, 'month');
		}

		this.setState({ finalCalculatedCosts: newFinalCalculatedCosts });
	};

	fillForm = () => {
		const { fuelContract } = this.props;
		if (!fuelContract) {
			return;
		}

		const newState = {};
		[
			'sourceCustomer',
			'contractNumber',
			'note',
			'productType',
			`quarter`,
			'startDate',
			'endDate',

			'timePeriod',
			'numberOfBarrels',
			'numberOfRailcars',
			'numberOfGallons',
			'paymentTerms',
			'overUnderMarginForNumberOfGallons',

			'provisionalPricing',
			'finalPricing',
			'finalCalculatedCosts',
			'bulkCostBulkCustomerIds',

			'lcfs',
			'rins',
			'resourceIds',

			'contractLoadingNumber',
			'fuelVendorSupplierId',
		].forEach((key) => {
			if (_.isNil(fuelContract[key])) {
				return;
			}
			newState[key] = fuelContract[key];
		});

		const { allocatedForTerminalId, supplierForTerminalId } = fuelContract;
		newState.terminalSupplier = {
			terminalId: allocatedForTerminalId,
			supplierId: supplierForTerminalId,
		};

		return newState;
	};

	loadSubContracts = () => {
		const { searchFuelSubContracts } = this.props;
		const { fuelContractId } = this.state;
		if (!fuelContractId) {
			return;
		}
		searchFuelSubContracts({
			parentFuelContractId: fuelContractId,
			callback: (err, result) => {
				if (err) {
					return;
				}
				const subContracts = _.get(result, ['collections', 'fuelSubContractCollection'], []);
				this.setState({ subContracts });
			},
		});
	};

	handleSubContractDialogClose = (didSave) => {
		this.setState({ subContractDialogOpen: false, editingSubContract: null });
		if (didSave) {
			this.loadSubContracts();
		}
	};

	handleDeleteSubContract = (fuelSubContractId) => {
		const { removeFuelSubContract, showErrors } = this.props;
		removeFuelSubContract({
			fuelSubContractId,
			callback: (err) => {
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}
				this.loadSubContracts();
			},
		});
	};

	handleSave = () => {
		const { showErrors, addFuelContract, updateFuelContract } = this.props;
		const { isUpdate, fuelContractId } = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const {
			sourceCustomer,
			contractNumber,
			note,
			productType,
			quarter,
			startDate,
			endDate,

			timePeriod,
			numberOfBarrels,
			numberOfRailcars,

			provisionalPricing,
			finalPricing,
			finalCalculatedCosts,
			bulkCostBulkCustomerIds,
			paymentTerms,
			overUnderMarginForNumberOfGallons,

			lcfs,
			rins,
			resourceIds,
			terminalSupplier,
			contractLoadingNumber,
			fuelVendorSupplierId,
		} = this.state;

		let numberOfGallons = this.state.numberOfGallons;
		if (numberOfGallons && _.isString(numberOfGallons)) {
			numberOfGallons = numberOfGallons.replace(/,/g, '');
			numberOfGallons = parseInt(numberOfGallons, 10);
			if (!_.isFinite(numberOfGallons)) {
				formFieldError.numberOfGallons = 'Number of gallons must be a number';
			}
		}

		let parsedNumberOfRailcars = numberOfRailcars;
		if (
			!_.isNil(parsedNumberOfRailcars) &&
			parsedNumberOfRailcars !== '' &&
			_.isString(parsedNumberOfRailcars)
		) {
			parsedNumberOfRailcars = parsedNumberOfRailcars.replace(/,/g, '');
			parsedNumberOfRailcars = parseInt(parsedNumberOfRailcars, 10);
			if (!_.isFinite(parsedNumberOfRailcars)) {
				formFieldError.numberOfRailcars = '# of Railcars must be a number';
			}
		}

		if (!_.isObject(terminalSupplier)) {
			formFieldError.terminalSupplier = 'Terminal / Supplier required';
		}

		const allocatedForTerminalId = terminalSupplier.terminalId;
		const supplierForTerminalId = terminalSupplier.supplierId;

		if (!allocatedForTerminalId || !supplierForTerminalId) {
			formFieldError.terminalSupplier = 'Terminal / Supplier required';
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const params = {
			sourceCustomer,
			contractNumber,
			note,
			productType,
			quarter,
			startDate: moment(startDate).format('YYYY-MM-DD'),
			endDate: moment(endDate).format('YYYY-MM-DD'),

			timePeriod,
			numberOfGallons,
			numberOfBarrels,
			numberOfRailcars: parsedNumberOfRailcars,

			provisionalPricing,
			finalPricing,
			finalCalculatedCosts,
			bulkCostBulkCustomerIds,
			paymentTerms,
			overUnderMarginForNumberOfGallons,

			lcfs,
			rins,
			resourceIds,

			allocatedForTerminalId,
			supplierForTerminalId,
			contractLoadingNumber,
			fuelVendorSupplierId: fuelVendorSupplierId || null,
		};

		if (!isUpdate) {
			addFuelContract({ params });
		} else {
			params.fuelContractId = fuelContractId;
			updateFuelContract({ params });
		}
	};

	handleArchive = () => {
		const { archiveFuelContract, showErrors, history } = this.props;
		const { fuelContractId } = this.state;
		archiveFuelContract({
			fuelContractId,
			callback: (err) => {
				if (err) {
					this.setState({ archiveConfirmOpen: false });
					return showErrors(_.isArray(err) ? err : [err]);
				}
				history.push('/inventoryManagement/fuelContracts');
			},
		});
	};

	handleUpload = ({ resource }) => {
		const resourceIds = this.state.resourceIds.slice();
		/** @namespace resource.resourceId **/
		resourceIds.push(resource.resourceId);
		this.setState({ resourceIds });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	render() {
		const { classes, fuelContract, resourceMap = {}, bulkCustomers } = this.props;
		const { isUpdate, resourceIds = [], archiveConfirmOpen } = this.state;

		if (isUpdate && !fuelContract) {
			return <div>Fetching fuelContract details...</div>;
		}

		const action = isUpdate ? 'Update Fuel Contract ' : 'Add Fuel Contract';
		return (
			<Paper className={classes.paper}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={12} md={10} lg={8}>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={12}>
								<FMPRegionHeader isTop={true} label={action} />
							</Grid>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Contract'} />
							</Grid>

							<FMPSupplierSelect
								{...this.setForm('fuelVendorSupplierId', 'Fuel Vendor / Supplier', false)}
								suppliers={this.props.suppliers || []}
								md={12}
							/>
							<FMPText {...this.setForm(`sourceCustomer`, 'Source Customer', true)} />
							<FMPText {...this.setForm(`contractNumber`, 'Pearson Contract Number', true)} />
							<FMPText {...this.setForm(`note`, 'Contracts Notes', false)} multiline="4" />

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Dates'} />
							</Grid>

							<FMPQuarterPicker {...this.setForm(`quarter`, 'Quarter', true)} />
							<FMPDatePicker
								{...this.setForm(`startDate`, 'Start Date', true)}
								format={'M/D/YYYY'}
								md={6}
							/>
							<FMPDatePicker
								{...this.setForm(`endDate`, 'End Date', true)}
								format={'M/D/YYYY'}
								md={6}
							/>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Obligation'} />
							</Grid>

							<FMPSelect
								{...this.setForm(`timePeriod`, 'Time Period', true)}
								options={[
									{ display: 'Quarterly', value: 'quarterly' },
									{ display: 'Monthly', value: 'monthly' },
								]}
							/>

							<FMPText {...this.setForm(`numberOfGallons`, 'Contracted Number of Gallons', true)} md={4} />
							<FMPText
								{...this.setForm(`numberOfRailcars`, '# of Railcars (if any)', false)}
								md={4}
							/>
							<FMPText
								{...this.setForm(`numberOfBarrels`, 'Number of Barrels (10mb, 20mb)', true)}
								md={4}
							/>
							<FMPText
								{...this.setForm(
									`overUnderMarginForNumberOfGallons`,
									'+/- Margin (ex: 0%, 5%, as needed)'
								)}
							/>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Allocated At'} />
							</Grid>

							<FMPProductSelect
								{...this.setForm(`productType`, 'Product', true)}
								productTypes={_.map(allProducts, ({ value }) => {
									return value;
								})}
							/>

							<FMPTerminalSupplierPicker
								{...this.setForm(`terminalSupplier`, 'Terminal', true, {})}
								productTypes={[this.state.productType]}
							/>

							<FMPText
								{...this.setForm(`contractLoadingNumber`, 'Contract Loading Number')}
								helpText={
									'Leave blank if not required. Used to associate deliveries with correct contract.'
								}
							/>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Pricing Description'} />
							</Grid>

							<FMPText
								{...this.setForm(`provisionalPricing`, 'Provisional Pricing Description', true)}
								multiline={2}
							/>

							<FMPText
								{...this.setForm(`finalPricing`, 'Final Pricing Description', true)}
								multiline={2}
							/>

							<FMPText {...this.setForm(`lcfs`, 'LCFS (ex: no/yes)', true)} md={6} />
							<FMPText {...this.setForm(`rins`, 'RINS (ex: no, 1 D6 per gallon)', true)} md={6} />

							<FMPText
								{...this.setForm(
									`paymentTerms`,
									'Payment Terms (ex: 5 Days, N3 from receipt of invoice/EFT)',
									true
								)}
							/>

							{this.renderFinalCosts()}

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Bulk Customers that get bulk cost'} />
							</Grid>

							<FMPBulkCustomerMultiSelect
								{...this.setForm(`bulkCostBulkCustomerIds`, 'Bulk Customers', false, [])}
								bulkCustomers={bulkCustomers}
								multiple={true}
							/>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Contract Documents'} />
							</Grid>

							{resourceIds.map((resourceId, i) => {
								const resource = resourceMap[resourceId];
								if (!resource) {
									return <div>Missing resource</div>;
								}

								const { contentType, url } = resource;

								let preview = (
									<div style={{ width: 75, height: 75, backgroundColor: '#ddd' }}>
										<span style={{ fontSize: 14 }}>No preview</span>
										<br />
										<a href={url} target="_blank" rel="noreferrer noopener">
											Download
										</a>
									</div>
								);

								if (contentType) {
									if (contentType.match(/(png|jpg|jpeg|bmp)/)) {
										preview = (
											<img
												alt={`Attachment ${i + 1}`}
												style={{ maxHeight: 175, maxWidth: 175 }}
												src={url}
											/>
										);
									} else if (contentType.match(/(pdf)/)) {
										preview = (
											<object
												data={url}
												style={{ maxHeight: 175, maxWidth: 122 }}
												type="application/pdf"
												width="122"
												height="175"
											>
												<a href={url}>attachment.pdf</a>
											</object>
										);
									}
								}

								return (
									<Grid key={resourceId} container spacing={3} style={{ marginTop: 10 }}>
										<Grid item xs={12} md={12} style={{ display: 'flex' }}>
											<div>{preview}</div>

											<div style={{ display: 'flex', padding: 20 }}>
												<a href={url} target="_blank" rel="noreferrer noopener">
													<div className={classes.documentIcon} />
												</a>
												<div>
													<a href={url} target="_blank" rel="noreferrer noopener">
														<div>
															<strong>Contract Document #{i + 1}</strong>
														</div>
														<div>{contentType}</div>
													</a>
												</div>
											</div>
											<div>
												<IconButton
													style={{ transform: 'translateY(50%)' }}
													color="primary"
													className={classes.button}
													onClick={() => this.removeInput('resourceIds', i)}
												>
													<DeleteIcon />
												</IconButton>
											</div>
										</Grid>
									</Grid>
								);
							})}

							<Grid container spacing={3}>
								<Grid item xs={12} md={6}>
									<ResourceUploader
										name={'resourceIds'}
										label={'Add Contract Document'}
										afterUpload={this.handleUpload}
									/>
								</Grid>
							</Grid>

							{this.renderSubContracts()}

							<Grid item xs={12} sm={12} style={{ marginTop: 30 }}>
								<Button
									variant="contained"
									color="primary"
									className={classes.submitButton}
									onClick={this.handleSave}
								>
									{action}
								</Button>
								{isUpdate && (
									<Button
										variant="outlined"
										color="secondary"
										className={classes.submitButton}
										style={{ marginLeft: 16 }}
										onClick={() => this.setState({ archiveConfirmOpen: true })}
									>
										Archive
									</Button>
								)}
							</Grid>
						</Grid>
					</Grid>
				</Grid>

			<Dialog
				open={archiveConfirmOpen}
				onClose={() => this.setState({ archiveConfirmOpen: false })}
			>
				<DialogTitle>Archive Fuel Contract?</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Are you sure you want to archive this contract?
					</DialogContentText>
					<DialogContentText style={{ marginTop: 12 }}>
						Railcars that are mapped will stay mapped to this archived contract, but you should
						migrate them to a valid contract so the numbers match up.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => this.setState({ archiveConfirmOpen: false })} color="default">
						Cancel
					</Button>
					<Button onClick={this.handleArchive} color="secondary" variant="contained">
						Archive
					</Button>
				</DialogActions>
			</Dialog>
		</Paper>
		);
	}

	renderSubContracts = () => {
		const { fuelContractId, startDate, endDate, subContracts, subContractDialogOpen, editingSubContract } =
			this.state;
		if (!fuelContractId) {
			return null;
		}

		return (
			<>
				<Grid item xs={12} sm={12}>
					<FMPSectionHeader label={'Sub Contracts'} />
				</Grid>
				<Grid item xs={12} sm={12}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Sub Contract #</TableCell>
								<TableCell>Name</TableCell>
								<TableCell>Product</TableCell>
								<TableCell>Prov Pricing</TableCell>
								<TableCell>Final Pricing</TableCell>
								<TableCell>Station Cost</TableCell>
								<TableCell>Bulk Cost</TableCell>
								<TableCell>Actions</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{subContracts.map((sc) => (
								<TableRow key={sc.fuelSubContractId}>
									<TableCell>
										{sc.fuelSubContractId}
										<Tooltip title="Copy ID">
											<IconButton
												size="small"
												style={{ marginLeft: 4 }}
												onClick={() => {
													navigator.clipboard.writeText(String(sc.fuelSubContractId));
													this.setState({ copySnackbarOpen: true });
												}}
											>
												<FileCopyIcon style={{ fontSize: 13 }} />
											</IconButton>
										</Tooltip>
									</TableCell>
									<TableCell>{sc.name || '—'}</TableCell>
									<TableCell>{sc.productType}</TableCell>
									<TableCell>
										{sc.provisionalPricing ? (
											<Tooltip title={sc.provisionalPricing} placement="top">
												<span style={{ cursor: 'help', borderBottom: '1px dotted #999' }}>
													{sc.provisionalPricing.length > 30
														? `${sc.provisionalPricing.slice(0, 30)}…`
														: sc.provisionalPricing}
												</span>
											</Tooltip>
										) : '—'}
									</TableCell>
									<TableCell>
										{sc.finalPricing ? (
											<Tooltip title={sc.finalPricing} placement="top">
												<span style={{ cursor: 'help', borderBottom: '1px dotted #999' }}>
													{sc.finalPricing.length > 30
														? `${sc.finalPricing.slice(0, 30)}…`
														: sc.finalPricing}
												</span>
											</Tooltip>
										) : '—'}
									</TableCell>
									<TableCell style={{ whiteSpace: 'nowrap' }}>
										{(sc.finalCalculatedCosts || []).map((entry) => (
											<div key={entry.startDate}>
												{moment(entry.startDate).format('MMM')}: {entry.cost || '—'}
											</div>
										))}
									</TableCell>
									<TableCell style={{ whiteSpace: 'nowrap' }}>
										{(sc.finalCalculatedCosts || []).map((entry) => (
											<div key={entry.startDate}>
												{moment(entry.startDate).format('MMM')}: {entry.bulkCost || '—'}
											</div>
										))}
									</TableCell>
									<TableCell>
										<IconButton
											color="primary"
											onClick={() =>
												this.setState({
													editingSubContract: sc,
													subContractDialogOpen: true,
												})
											}
										>
											<EditIcon />
										</IconButton>
										<IconButton
											color="secondary"
											onClick={() => this.handleDeleteSubContract(sc.fuelSubContractId)}
										>
											<DeleteIcon />
										</IconButton>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
					<Button
						variant="outlined"
						color="primary"
						style={{ marginTop: 16 }}
						onClick={() => this.setState({ subContractDialogOpen: true, editingSubContract: null })}
					>
						Add Sub Contract
					</Button>
				</Grid>

				<SaveFuelSubContractDialog
					open={subContractDialogOpen}
					onClose={this.handleSubContractDialogClose}
					parentFuelContractId={fuelContractId}
					parentStartDate={startDate}
					parentEndDate={endDate}
					parentProductType={this.state.productType}
					fuelSubContract={editingSubContract}
				/>
				<Snackbar
					open={this.state.copySnackbarOpen}
					message="Sub contract ID copied to clipboard"
					autoHideDuration={2000}
					onClose={() => this.setState({ copySnackbarOpen: false })}
				/>
			</>
		);
	};

	renderFinalCosts = () => {
		const { classes } = this.props;
		const { finalCalculatedCosts, startDate, endDate } = this.state;

		if (!startDate || !endDate) {
			return (
				<Grid item xs={12} sm={12}>
					<div className={classes.note}>
						<strong>Note : </strong>You must have a start and end date before you can fill out the
						actual costs.
					</div>
				</Grid>
			);
		}

		if (_.isEmpty(finalCalculatedCosts)) {
			return (
				<Grid item xs={12} sm={12}>
					Costs are empty. Select a start date / end date, save, then refresh.
				</Grid>
			);
		}

		return (
			<>
				<Grid item xs={12} sm={12}>
					<FMPSectionHeader label={'Final Actual Costs'} />
				</Grid>
				<Grid item xs={12} sm={12}>
					<Grid container spacing={3}>
						{finalCalculatedCosts.map((finalCalculatedCost, i) => {
							const { startDate, endDate } = finalCalculatedCost;
							const label = `Station Cost for ${moment(startDate).format('M/D/YY')} Thru ${moment(
								endDate
							).format('M/D/YY')}`;
							const bulkLabel = `Bulk Cost for ${moment(startDate).format('M/D/YY')} Thru ${moment(
								endDate
							).format('M/D/YY')}`;
							const path = `finalCalculatedCosts.${i}.cost`;
							const bulkPath = `finalCalculatedCosts.${i}.bulkCost`;
							return (
								<Fragment key={`finalCalculatedCosts.${i}`}>
									<FMPText
										{...this.setForm(path, label, false)}
										key={path}
										gridProps={{ md: 6 }}
										md={6}
									/>

									<FMPText
										{...this.setForm(bulkPath, bulkLabel, false)}
										key={bulkPath}
										gridProps={{ md: 6 }}
										md={6}
									/>
								</Fragment>
							);
						})}
					</Grid>
				</Grid>
			</>
		);
	};
}

SaveFuelContract.propTypes = {
	classes: PropTypes.object.isRequired,
	addFuelContract: PropTypes.func.isRequired,
	updateFuelContract: PropTypes.func.isRequired,
	getFuelContract: PropTypes.func.isRequired,
	archiveFuelContract: PropTypes.func.isRequired,
	fuelContract: PropTypes.object,

	resourceMap: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	suppliers: PropTypes.array,
	searchSuppliers: PropTypes.func,
	searchFuelSubContracts: PropTypes.func.isRequired,
	removeFuelSubContract: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), FuelContractContainer, BulkCustomersContainer])(
	SaveFuelContract
);
